import { autoinject, transient } from "aurelia-framework";
import { RequestClientService } from "@rightship-tech/common-ui/services/basic/request-client.service";
import {Urls} from "../../constants/modules/mdm-pipelines.constants";
import { GetMdmPipelinesResponse, ClearEtlProcessExecutionWarningResponse, FailedEtlProcessExecutionResponse } from "../../models/mdm-pipelines/mdm-pipelines.models";

@autoinject()
@transient()
export class MdmPipelineClientService {

    constructor(private requestClient: RequestClientService) { }

    public getMdmPipelines(): Promise<GetMdmPipelinesResponse> {
        return this.requestClient.get(Urls.GetMdmPipelines, {});
    }

    public runPipeline(id: string): Promise<void> {
        return this.requestClient.post(Urls.RunPipeline, { id }, {});
    }

    public runPipelineCommands(pipeline: string, commands: string[]): Promise<void> {
        return this.requestClient.post(Urls.RunPipelineCommand, {}, { pipeline, commands });
    }

    public clearEtlProcessExecutionWarning(etlProcessExecutionId: number, comments: string): Promise<ClearEtlProcessExecutionWarningResponse> {
        return this.requestClient.post(Urls.ClearEtlProcessExecutionWarning, {}, { etlProcessExecutionId, comments });
    }

    public failEtlProcessExecution(etlProcessExecutionId: number, comments: string): Promise<FailedEtlProcessExecutionResponse> {
        return this.requestClient.post(Urls.FailEtlProcessExecution, {}, { etlProcessExecutionId, comments });
    }
}